<template>
  <vx-tooltip :text="$t('test_call')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="callTest">
      <i class="c-icon-dial"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Utils from '@/helpers/utils'

export default {
  name: 'CtiCallTest',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  methods: {
    callTest () {
      const data = {
        cid: '9001',
        extension: '9004',
        agi_arg_3: '9920',
        agi_arg_4: '1574312591.136016',
        agi_arg_5: 'SIP%2F9001-00008c29',
        agi_arg_7: '1',
        id: '',
        title: ''
      }

      Utils.openPopUp('window', 'inbound', data)

    }
  }
}
</script>

<style scoped>

</style>
